import React, {lazy, Suspense} from 'react';
import {useSelector} from 'react-redux';
import {useParams, Link} from 'react-router-dom';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import HealingIcon from '@mui/icons-material/Healing';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import ScienceIcon from '@mui/icons-material/Science';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import PaymentsIcon from '@mui/icons-material/Payments';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import BiotechIcon from '@mui/icons-material/Biotech';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import '../styles/Prescription.scss';

const ChartAnChart = lazy(() => import('../moretemplates/AN CHART/ChartAnChart'));
const ChartBPChart = lazy(() => import('../moretemplates/BP CHART/ChartBPChart'));
const ChartBpSugarChart = lazy(() => import('../moretemplates/BP SUGAR CHART/ChartBpSugarChart'));
const ChartCostingSheet = lazy(() => import('../moretemplates/COSTING SHEET/ChartCostingSheet'));
const ChartDonorStimulationCheckList = lazy(() => import('../moretemplates/DonorStimulationCheckList/ChartDonorStimulationCheckList'));
const ChartFertilityInvestigation = lazy(() => import('../moretemplates/FERTILITY INVESTIGATION/ChartFertilityInvestigation'));
const ChartIvfFailureInvestigations = lazy(() => import('../moretemplates/IVF FAILURE INVESTIGATIONS/ChartIvfFailureInvestigations'));
const ChartKickCountChart = lazy(() => import('../moretemplates/KICK COUNT CHART/ChartKickCountChart'));
const ChartPretermLabour = lazy(() => import('../moretemplates/PRETERM LABOUR WORKUP/ChartPretermLabour'));
const ChartDonorEggCosting = lazy(() => import('../moretemplates/DONOR EGG COSTING/ChartDonorEggCosting'));
const ChartIvfIcsiReevaluation = lazy(() => import('../moretemplates/IVF ICSI RE-EVALUATION/ChartIvfIcsiReevaluation'));
const ChartRplInvestigationBasic = lazy(() => import('../moretemplates/RPL INVESTIGATION BASIC/ChartRplInvestigationBasic'));
const ChartRplInvestigationExtensive = lazy(() => import('../moretemplates/RPL INVESTIGATION EXTENSIVE/ChartRplInvestigationExtensive'));
const ChartStimulationChecklist = lazy(() => import('../moretemplates/STIMULATION STARTING CHECKLIST/ChartStimulationChecklist'));
const RplWorkUp = lazy(() => import('../moretemplates/RPL WorkUp/RplWorkUp'));

function Charts(props) {
  const {type} = useParams();
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const chartType = type;

  const PrintDiv = () => {
    var new_str = document.getElementById('demo').innerHTML;
    var originalContents = document.body.innerHTML;
    var printContent = `
      <style>
        @page {
          margin: 0;
        }
        body {
          margin: 0;
          padding: 0;
        }
        .demo {
          width: 100%;
          max-width: 1200px;
          margin: 20px auto 0;
        }
        table {
          border-collapse: collapse;
          border: 1px solid black;
          width: 100%;
          margin-bottom: 10px;
          table-layout: fixed;
        }
        table th, table td {
          border: 1px solid black;
          padding: 10px;
          text-align: center;
          height: 60px;
          min-width: 80px;
        }
        /* Costing Sheet specific styles */
        #CostingSheet table th,
        #CostingSheet table td {
          text-align: left;
          height: auto;
          min-width: auto;
        }
        #CostingSheet table {
          table-layout: auto;
        }
      </style>
      ${new_str}
    `;
    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContents;
    return false;
  };

  var mediaQueryList = window.matchMedia('print');
  mediaQueryList.addListener(function (mql) {
    if (mql.matches) {
      console.log('before print dialog open');
    } else {
      window.location.reload();
      console.log('after print dialog closed');
    }
  });

  return (
    <>
      <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
        <div className='patient-header'>
          <div className='row'>
            <div className='col'>
              <h3 className='page-title'>{chartType || 'Medical Charts'}</h3>
              <ul className='breadcrumb'>
                <li className='breadcrumb-item'>
                  <a href='/' style={{textDecoration: 'none', color: 'black'}}>
                    Dashboard /
                  </a>
                  <a href='/Patients' style={{textDecoration: 'none', color: 'black'}}>
                    &nbsp;Patient
                  </a>
                </li>
                <li className='breadcrumb-item active'>Charts</li>
              </ul>
            </div>
            <div className='col-auto'>
              <button onClick={() => PrintDiv()} style={{padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer'}}>
                Print Chart
              </button>
            </div>
          </div>
        </div>
        <Suspense fallback={<div className='text-center mt-3'>Loading chart...</div>}>
          <div>
            {chartType === 'Bp Sugar Chart' && (
              <ChartBpSugarChart loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'An Chart' && (
              <ChartAnChart loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Blood Pressure Chart' && (
              <ChartBPChart loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Kick Count Chart' && (
              <ChartKickCountChart loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Preterm Labour' && (
              <ChartPretermLabour loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Costing Sheet' && (
              <ChartCostingSheet loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'RPL Workup' && <RplWorkUp loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />}
            {chartType === 'RPL Investigation Basic' && (
              <ChartRplInvestigationBasic loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'RPL Investigation Extensive' && (
              <ChartRplInvestigationExtensive loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'IVF Failure Investigations' && (
              <ChartIvfFailureInvestigations loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}

            {chartType === 'DONOR STIMULATION CHECK LIST' && (
              <ChartDonorStimulationCheckList loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Fertility investigation' && (
              <ChartFertilityInvestigation loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'DONOR EGG PROGRAM' && (
              <ChartDonorEggCosting loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'IVF ICSI RE-EVALUATION' && (
              <ChartIvfIcsiReevaluation loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'STIMULATION STARTING CHECKLIST' && (
              <ChartStimulationChecklist loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}

            {!chartType && (
              <div className='charts-landing p-4' style={{backgroundColor: '#f8f9fa', borderRadius: '15px', marginTop: '20px'}}>
                <div className='text-center mb-5'>
                  <h2 style={{fontWeight: 'bold', color: '#333'}}>Medical Charts & Checklists</h2>
                  <p className='text-muted'>Select a chart from the list below to get started.</p>
                </div>
                <div
                  className='charts-grid'
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: '20px',
                    padding: '10px'
                  }}>
                  {[
                    {text: 'An Chart', link: 'An Chart', icon: <PregnantWomanIcon />},
                    {text: 'Blood Pressure Chart', link: 'Blood Pressure Chart', icon: <FavoriteIcon />},
                    {text: 'BP Sugar Chart', link: 'Bp Sugar Chart', icon: <BloodtypeIcon />},
                    {text: 'Costing Sheet', link: 'Costing Sheet', icon: <PaymentsIcon />},
                    {text: 'Donor Egg Costing', link: 'DONOR EGG PROGRAM', icon: <VolunteerActivismIcon />},
                    {text: 'Donor Stimulation Checklist', link: 'DONOR STIMULATION CHECK LIST', icon: <PlaylistAddCheckIcon />},
                    {text: 'Fertility Investigation', link: 'Fertility investigation', icon: <BiotechIcon />},
                    {text: 'IVF / ICSI Re-evaluation', link: 'IVF ICSI RE-EVALUATION', icon: <PublishedWithChangesIcon />},
                    {text: 'IVF Failure Investigations', link: 'IVF Failure Investigations', icon: <TroubleshootIcon />},
                    {text: 'Kick Count Chart', link: 'Kick Count Chart', icon: <ChildCareIcon />},
                    {text: 'Preterm Labour', link: 'Preterm Labour', icon: <RunningWithErrorsIcon />},
                    {text: 'RPL Investigation Basic', link: 'RPL Investigation Basic', icon: <ScienceIcon />},
                    {text: 'RPL Investigation Extensive', link: 'RPL Investigation Extensive', icon: <BiotechIcon />},
                    {text: 'Stimulation Starting Checklist', link: 'STIMULATION STARTING CHECKLIST', icon: <FactCheckIcon />}
                  ].map((chart, idx) => (
                    <Link
                      key={idx}
                      to={`/charts/${chart.link}`}
                      style={{
                        textDecoration: 'none',
                        color: 'inherit',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '20px',
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        border: '1px solid #eee'
                      }}
                      onMouseOver={e => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 8px 15px rgba(0,0,0,0.1)';
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
                      }}>
                      <div
                        style={{
                          width: '50px',
                          height: '50px',
                          borderRadius: '10px',
                          backgroundColor: '#f0f4f8',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px',
                          color: '#007bff'
                        }}>
                        {chart.icon}
                      </div>
                      <span style={{fontWeight: '600', fontSize: '16px'}}>{chart.text}</span>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </Suspense>
      </div>
    </>
  );
}

export default Charts;
